<template>
  <div class="c-iban">
    <card class="data-card bank-details" :show-footer-line="true">
      <b-row no-gutters>
        <b-col class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="card-header p-0 card-header-text pb-3">شماره های شبا</h1>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col lg="12" sm="12" class="right-section">
          <!-- Main table element -->
          <b-table
            :items="cards"
            :fields="fields"
            stacked="md"
            show-empty
            empty-text="موردی یافت نشد"
          >
            <template #cell(status)="row">
              <b-badge
                v-if="row.value == 'Pending'"
                :variant="row.value == 'Pending' ? 'warning' : 'success'"
              >
                {{ row.value == "Pending" ? "تایید نشده" : "تایید شده" }}
              </b-badge>

              <b-badge v-if="row.value == 'Approved'" variant="success">
                تایید شده
              </b-badge
              >
              <b-badge v-if="row.value == 'Rejected'" variant="danger">
                رد شده
              </b-badge>
              <b-badge v-if="row.value === 'Deactivated'" variant="danger">
                حذف شده
              </b-badge>
            </template>
            <template #cell(actions)="row" v-if="ibanActionAccess">
              <div class="d-flex flex-wrap">
                <b-button
                  class="mr-1"
                  variant="success"
                  size="sm"
                  @click="verifySheba(row.item.id)"
                  v-if="row.item.status !== 'Approved'"
                >
                  تایید کارت
                </b-button>

                <b-button
                  class="mr-1"
                  variant="danger"
                  size="sm"
                  @click="rejectSheba(row.item.id)"
                  v-if="row.item.status !== 'Rejected' && row.item.status !== 'Deactivated'"
                >
                  رد کارت
                </b-button>

                <b-button
                  class="mr-1"
                  variant="danger"
                  size="sm"
                  @click="deleteCard(row.item.id)"
                  v-if="row.item.status !== 'Deactivated'"
                >
                  حذف
                </b-button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </card>

  </div>
</template>

<script>
import http from "@/httpservices/HttpService"
import store from "@/store"
import {submitNewIban} from "@/httpservices/UserBankInfo";
import Swal from "sweetalert2";
import {isShebaValid} from "@persian-tools/persian-tools"


export default {
  data() {
    return {
      show: false,
      loading: true,
      cards: [],
      token: localStorage.getItem("token") || "",

      fields: [
        {
          key: "iban",
          label: "شماره شبا",
          sortable: false,
          class: "text-center",
        },
        {
          key: "iban",
          label: "شماره شبا",
          sortable: false,
          class: "text-center",
        },
        {
          key: "holderName",
          label: "نام صاحب حساب",
          sortable: false,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        {key: "actions", label: "عملیات", class: "text-left"},
      ],

      modalShow: false,

      infoModal: {
        id: "",
        title: "",
        content: "",
      },

      newIban: {
        loading: false,
        name: "",
        iban: ""
      }
    };
  },

  mounted() {
    this.getCards();
  },

  computed: {
    ibanActionAccess() {
      const access = Boolean(
        store.getters['isSuperAdmin'] ||
        store.getters['ManagerAdmin'] ||
        store.getters['ApprovingManager']
      );

      // if (!access) {
      //   this.fields.pop();
      // }
      return access;
    },

    isSuperAdmin() {
      return store.getters['isSuperAdmin']
    },

    isValidFormNewIban() {
      return Boolean(
        this.newIban.iban &&
        this.newIban.name
      );
    }
  },

  methods: {
    deleteCard(id) {
      http.delete("/BankShebas/" + id + "/account/" + this.$route.params.id)
        .then(() => {
          this.getCards();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },

    verifySheba(id) {
      http.put("/BankShebas/" + id + "/account/" + this.$route.params.id + "/approve",)
        .then(() => {
          this.getCards();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },

    rejectSheba(id) {
      http.put("/BankShebas/" + id + "/account/" + this.$route.params.id + "/reject",)
        .then(() => {
          this.getCards();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },

    getCards() {
      this.loading = true;

      http.get("/BankShebas/account/" + this.$route.params.id,)
        .then((response) => {
          this.cards = response.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },

    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
  },
};
</script>

<style lang="scss">
.c-iban {
  .bank-details {
    .right-section {
      overflow: scroll;
    }
  }

  @media (max-width: 768px) {
    .bank-details {
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
        padding-top: 28px;
      }
    }
  }
}
</style>
